<template>
  <div class="quiz-result">
    <div class="content columns">
      <div class="title-col column col-12">
        <div class="title title-col__title desktop-hidden">
          <span class="title-col__text">
            Kanapowa menadżerka
          </span>
        </div>
      </div>
      <div class="images-col column col-4 col-sm-12">
        <div class="thumbnail">
          <img :src="require('@/assets/images/pic-s4-kanapowa-menadzerka.png')"
               alt="Segment" class=" img-responsive thumbnail-image" />
        </div>
      </div>
      <div class="description column">
        <div class="title title-col__title mobile-hidden">
          <span class="title-col__text">
            Kanapowa menadżerka
          </span>
        </div>
        <div class="description__content">
          <p class="quote">
            "Mój dom to moja twierdza"
          </p>
          <p>
            Ty nie gonisz – Ty zarządzasz.
            Cenisz porządek, strukturę i ludzi, którzy dotrzymują słowa.
            Dobrze wiesz, co się dzieje, kiedy robi się bałagan –
            dlatego działasz wyprzedzająco, z planem i spokojem.
            Twój świat nie musi być spektakularny –
            ma być <strong>poukładany i bezpieczny</strong>.
          </p>
          <p>
            Masz zmysł organizacyjny i silną intuicję.
            Lubisz przewidywać, planować, dbać o swój rytm i przestrzeń.
            A kiedy coś wymyka się spod kontroli –
            to Ty jesteś tą, która daje innym poczucie bezpieczeństwa.
          </p>
          <p>
            W relacjach jesteś jak kotwica – cicha, niezawodna, obecna.
            Nie rzucasz się w oczy, ale Twoja lojalność i uważność sprawiają,
            że jesteś niezastąpiona.
          </p>
          <p>
            Twoja supermoc? Tworzysz stabilność w świecie,
            który czasem trzęsie się jak galareta.
          </p>
          <p>
            <strong>Twoje wartości:</strong> bezpieczeństwo, porządek, lojalność<br/>
            <strong>Styl życia:</strong> zrównoważony, spokojny, oparty na rytuałach<br/>
            <strong>W relacjach:</strong> cierpliwa, konkretna, przewidywalna (w dobrym sensie)<br/>
            <strong>Supermoc:</strong> jesteś opoką – i każdy to czuje
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KanapowaMenadzerka',
};
</script>

<style scoped>
.title-col__text {
  color: var(--color-kanapowa) !important;
}
.thumbnail-image {
  border-radius: 900px;
}
.quiz-result .percentage__value {
  color: var(--color-kanapowa);
}
.quiz-result .quote {
  font-style: italic;
  font-weight: 600;
  font-size: 22px;
}
</style>
